import { useEffect } from "react";

export default function useSidebarWidthVar() {
  useEffect(() => {
    const selectors = ["#sidebar", ".sidebar", "aside.sidebar", ".side-nav", ".sidenav"];
    const getSidebar = () => selectors.map((s) => document.querySelector(s)).find(Boolean);

    const setVar = () => {
      const el = getSidebar();
      const w = el ? Math.round(el.getBoundingClientRect().width) : 0;
      document.documentElement.style.setProperty("--sidebar-w", `${w}px`);
    };

    setVar();
    window.addEventListener("resize", setVar);
    return () => window.removeEventListener("resize", setVar);
  }, []);
}
